module.exports = {
  SelectReconciliationRules: 'Select reconciliation rules',
  ReturnToReconciliationNewVersion: 'Return to reconciliation new version',
  StartReconciliation: 'Start reconciliation',
  Save: 'Save',
  ManualReconciliation: 'Manual reconciliation',
  CancelManualReconciliation: 'Cancel manual reconciliation',
  ShowAllReconciliationCost: 'Show all reconciliation cost',
  ShowConsistentReconciliationCost: 'Show consistent reconciliation cost',
  ShowPartiallyConsistentReconciliationFees: 'Show partially consistent reconciliation fees',
  ShowUnmatchedCosts: 'Show unmatched costs',
  Note: 'Note:',
  Green: 'Green',
  IndicatesConsistentReconciliationResults: 'indicates consistent reconciliation results;',
  Black: 'Black',
  IndicatesNoCorrespondingChargeFound: 'indicates no corresponding charge found;',
  Red: 'Red',
  IndicatesInconsistentAmounts: 'indicates inconsistent amounts;',
  Orange: 'Orange',
  IndicatesManualReconciliationComplete: 'indicates manual reconciliation complete;',
  IfEtcPleaseGoModule: 'If you need to handle discrepancies, etc., please go the new reconciliation module.',
  ImportExternalCharges: 'Import external charges',
  InternalSystemCharges: 'Internal system charges',
  IfMaintainReconciliationRulesClick: 'If you need to maintain reconciliation rules, please click',
  ReconciliationRuleEngineConfiguration: 'Reconciliation rule engine configuration.',
  ReconciliationConsistent: 'Reconciliation consistent ',
  Items: ' items',
  InconsistentAmounts: 'Inconsistent amounts ',
  CorrespondingChargesNotFound: 'Corresponding charges not found ',
  ImportSucceeded: 'Import succeeded',
  CancelAllManualReconciliations: 'Cancel all manual reconciliations',
  ExportAllComparisonResults: 'Export all comparison results',
  ExportConsistentComparisonResults: 'Export consistent comparison results',
  ExportDiscrepancyComparisonResults: 'Export discrepancy comparison results',
  BusinessNumber: '業務番号',
  ShipName: 'Ship name',
  VoyageNumber: 'Voyage number',
  ContainerNumber: 'Container number',
  ConfirmationStatus: '確認ステータス',
  ChargeName: 'Charge name',
  Currency: ' 通貨',
  PriceIncludingTax: 'Price including tax',
  PriceExcludingTax: 'Price excluding tax',
  TaxRate: '税率',
  TaxAmount: '消費税額',
  Difference: 'Difference',
  ReconciliationAmount: 'Reconciliation amount',
  UnitPrice: 'Unit price',
  Quantity: '数量',
  InvoiceNumber: 'Invoice number',
  ReconciliationResult: 'Reconciliation result',
  ReconciliationRuleName: 'Reconciliation rule name',
  ComparisonOrder: 'Comparison order',
  PleaseNeedToBeReconciliation: 'Please check the fees that need to be reconciled before manual reconciliation.',
  ManualReconciliationSucceeded: 'Manual reconciliation succeeded',
  AreCancelAllManualTime: 'Are you sure you want to cancel all manual reconciliation information this time?',
  Tips: 'Tips',
  Yes: 'Yes',
  No: 'No',
  CancelAllManualReconciliationsSuccessful: 'Cancel all manual reconciliations successful',
  RequestSucceededExporting: 'Request succeeded, exporting!',
  SavedSuccessfully: 'Saved successfully',
  PleaseUseAndFillNumbers: 'Please check the reconciliation rules you need to use and fill in the comparison order with numbers',
  Unconfirmed: 'Unconfirmed',
  Confirmed: 'Confirmed',
  ViewDetails: 'View details',
  Return: 'Return',
  ShowAllReconciliationFees: 'Show all reconciliation fees',
  ShowFullyReconciledFees: 'Show fully reconciled fees',
  ShowPartiallyReconciledFees: 'Show partially reconciled fees',
  ShowUnmatchedFees: 'Show unmatched fees',
  IndicatesReconciliationResultIsConsistent: 'indicates reconciliation result is consistent;',
  IndicatesCorrespondingFeeNotFound: 'indicates corresponding fee not found;',
  IndicatesAmountInconsistency: 'indicates amount inconsistency;',
  IndicatesManualReconciliationCompleted: 'indicates manual reconciliation completed;',
  ImportExternalFees: 'Import external fees',
  SystemInternalFees: 'System internal fees',
  ViewFile: 'View file',
  System: 'System',
  Voyage: 'Voyage',
  FeeName: 'Fee name',
  TaxIncludedPrice: 'Tax-included price',
  TaxExcludedPrice: 'Tax-excluded price',
  PleaseSelectOneRecord: 'Please select one record.',
  All: 'All',
  BankName: 'Bank name',
  YouPermissionToViewData: 'You have no permission to view this data',
  QuickRetrieval: 'Quick retrieval:',
  Selected: 'Selected',
  QuickRetrievalBillNumber: 'Quick retrieval: Bill number',
  BillClaims: 'Bill claims',
  FinancialReview: 'Financial review',
  QuickRetrievalBusinessNumber: 'Quick retrieval: Business number',
  QuickRetrievalWaterBillNumber: 'Quick retrieval: Water bill number',
  WaterBillClaims: 'Water bill claims',
  Unused: 'Unused',
  PleaseAWaterBillRecord: 'Please select a water bill record.',
  WaterReleasedAndCannotModified: 'Water bill is released and cannot be modified.',
  WaterClaimedAndCannotModified: 'Water bill has been claimed and cannot be modified.',
  WaterReturnedAndCannotModified: 'Water bill has been returned and cannot be modified.',
  WaterRecordsAndCannotVoided: 'Water bill has cleared records and cannot be voided.',
  WaterToFinancialVoucherVoided: 'Water bill has been exported to financial voucher and cannot be voided.',
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  NoBillRecordsToRelease: 'No water bill records to release.',
  NoRecordsToCancelRelease: 'No water bill records to cancel release.',
  OnlyCanRevokeTheBill: 'Only the clearing person can revoke the water bill.',
  WaterCannotBeRevokedFirst: 'Water bill that has been reviewed cannot be revoked, please cancel the review first.',
  ThisPleaseDeleteTheAgain: 'This water bill has generated financial vouchers, please delete the voucher and revoke it again.',
  WaterBillRevocationSuccessful: 'Water bill revocation successful.',
  WaterBillRegistration: 'Water bill registration',
  WaterBillNotSelected: 'Water bill not selected.',
  AdvanceNoAdvancePaymentGenerated: 'Advance payment claimed but no advance payment voucher generated.',
  Claimed: 'Claimed',
  ReceivableClaimCompleted: 'Receivable claim completed.',
  PrepaymentClaimCompleted: 'Prepayment claim completed.',
  NoInTheCurrentBill: 'No remaining claim amount in the current water bill.',
  PleaseDataToBeClaimed: 'Please select the data to be claimed.',
  DomesticBill: 'Domestic bill',
  InvoicingMetForReconciliationStatus: 'Invoicing requirements not met for reconciliation status!',
  AddToBillQueryList: 'Add to bill query list',
  ForeignBill: 'Foreign bill',
  AgencyCommissionBill: 'Agency commission bill',
  Bill: 'Bill:',
  CreatePaymentRequestSelectFee: 'Create payment request - Select fee',
  SettlementTheBillCannotEmpty: 'Settlement agent for the bill cannot be empty!',
  CreatePaymentRequestDetailedInformation: 'Create payment request - Detailed information',
  ReconciliationBill: 'Reconciliation bill',
  QuickRetrievalReconciliationBillNumber: 'Quick retrieval: Reconciliation bill number',
  Payable: '(Payable)',
  Receivable: '(Receivable)',
  ReconciliationByFee: 'Reconciliation - By fee',
  ReconciliationByBusiness: 'Reconciliation - By business',
  SelectImportTemplateSolution: 'Select import template solution',
  Prompt: 'Prompt',
  TemplateSolutionName: 'Template solution name',
  ToMaintainImportTemplatesClick: 'To maintain import templates, click',
  BasicDataImportTemplateSolutions: 'Basic Data - Import Template Solutions.',
  PleaseSelectASolution: 'Please select a solution',
  PleaseSettlementUnitBeforeImporting: 'Please query the settlement unit before importing',
  NoFoundNoNeedReconcile: 'No relevant fees found, no need to reconcile',
  PleaseBasicDataImportSolution: 'Please maintain in basic data import template solution',
  ImportErrorPleaseReImport: 'Import format error, please re-import',
  PleaseSelectATemplate: 'Please select a template',
  YouHavePermissionToOpen: 'You don\'t have permission to open',
  Module: 'Module',
  ViewPaymentRequestForm: 'View payment request form',
  CreatingFormFailedPleaseAgain: 'Creating payment request form failed, please save again!',
  ShanghaiAirFreightPayment: 'Shanghai Air Freight Payment',
  PaymentRequestDirect: 'Payment request direct',
  IncludesReSelectPaymentNumber: 'Includes invoiced costs, please re-select! Payment request number:',
  CantDirectlyChangeConfigurationAgain: 'Can\'t do financial review directly, change configuration and try again!',
  Invoicing: 'Invoicing',
  QueryMethod: 'Query method',
  ByFee: 'By fee',
  ByBusiness: 'By business',
  IncludeReceivables: 'Include receivables',
  NoteFilteredOutFullyBusiness: 'Note: This interface has filtered out fully cleared fees business',
  ConvertedToRMB: 'Converted to RMB:',
  NextStep: 'Next Step',
  NotFound: 'Not Found',
  CorrespondingPrintTemplate: 'Corresponding Print Template',
  WarehouseEntryNumber: 'Warehouse Entry Number',
  BookingNumber: 'Booking Number',
  CutOffDate: 'Cut-off Date',
  ProjectNumber: 'プロジェクト番号',
  OverseasCustomerService: 'Overseas Customer Service',
  PaymentApplicationNumber: '支払申請書番号',
  BillNumber: 'Bill Number',
  SettlementObject: '決済対象',
  PickUpType: 'Pick-up Type',
  MasterBillNumber: 'Master Bill Number',
  HouseBillNumber: 'House Bill Number',
  EntrustingUnit: 'Entrusting Unit',
  BusinessType: '業務種別',
  BusinessDate: '業務日付',
  VesselVoyage: 'Vessel Voyage',
  DeparturePort: 'Departure Port',
  DestinationPort: 'Destination Port',
  StartingStation: 'Starting Station',
  TerminusStation: 'Terminus Station',
  TransitStation: 'Transit Station',
  DestinationPortAgent: 'Destination Port Agent',
  Sales: ' 売上',
  Operation: ' 操作内容',
  CustomerService: 'カスタマーサービス',
  Documentation: 'Documentation',
  BusinessReferenceNumber: '業務参照番号',
  CustomBusinessType: 'Custom Business Type',
  Accrued: '未払計上',
  FinancialDate: '会計処理日',
  DomesticForeign: 'Domestic/Foreign',
  IncomeAndExpensesType: 'Income and Expenses Type',
  ExpenseStatus: 'Expense Status',
  Auditor: '審査担当者',
  ExpenseName: 'Expense Name',
  Unit: ' 単位',
  WriteOffAmount: 'Write-off Amount',
  UnwrittenOffAmount: 'Unwritten-off Amount',
  ContactPerson: 'Contact Person',
  Creator: '作成者',
  CreationDate: 'Creation Date',
  Remark: 'Remark',
  CorrelationNumber: 'Correlation Number',
  DelegationCorrelationNumber: 'Delegation Correlation Number',
  Carrier: 'Carrier',
  ConfirmationDate: '確認日',
  ExpenseConfirmer: 'Expense Confirmer',
  RouteResponsiblePerson: 'Route Responsible Person',
  BillingDate: 'Billing Date',
  BillingHeader: 'Billing Header',
  NeedForInvoicing: 'Need for Invoicing',
  ConfirmationRemark: 'Confirmation Remark',
  AccountingDate: 'Accounting Date',
  BusinessStatus: '業務ステータス',
  CustomField1: 'Custom Field 1',
  CustomField2: 'Custom Field 2',
  CustomField3: 'Custom Field 3',
  ReceiptAndPaymentDate: 'Receipt and Payment Date',
  SalesDepartment: '営業部門',
  ChooseExpense: 'Choose Expense',
  CreatePaymentApplicationChooseExpense: 'Create Payment Application - Choose Expense',
  Other: 'Other',
  YouViewOrPrintOthers: 'You don\'t have the permission to view or print files uploaded by others.',
  BookingAgent: 'Booking Agent',
  PleaseSelect: 'Please Select',
  ProvisionalBusinesses: 'Provisional Businesses',
  ChangeOrderApprovalSuccess: 'Change Order Approval Success',
  ThisIsNotForProvision: 'This Business is not for Provision!',
  ForPleaseChooseProvisionedBusiness: 'For Non-Provision, Please Choose Provisioned Business!',
  FrontendErrorCallbackFailed: 'Frontend error: Callback Failed',
  RouteManager: 'Route Manager',
  ThisFieldCannotBeEmpty: 'This Field Cannot be Empty',
  OperationAllowedToBeEmpty: 'Operation Not Allowed to be Empty',
  OperatingAllowedToBeEmpty2: 'Operating Department Not Allowed to be Empty',
  OperatingAllowedToBeEmpty3: 'Operating Branch Not Allowed to be Empty',
  DesignatedFreightForwarder: 'Designated Freight Forwarder',
  OriginPortAgent: 'Origin Port Agent',
  TransportationCompany: 'Transportation Company',
  Warehouse: 'Warehouse',
  CustomsBroker: 'Customs Broker',
  CustomsDeclaration: 'Customs Declaration',
  PickingStorage: 'Picking/Storage',
  Storage: 'Storage',
  CargoType: 'Cargo Type',
  ActualBillingWeight: 'Actual Billing Weight',
  QuotationNature: 'Quotation Nature',
  BookingType: 'Booking Type',
  AllWriteOffs: 'All Write-offs',
  BusinessCannotBeEmpty: 'Business Cannot be Empty!',
  ReviewSuccess: 'Review Success',
  ReviewFailed: 'Review Failed',
  ColumnDataConversionRendering: 'Column Data Conversion Rendering:',
  SelectActualReceiptAndPayment: 'Select Actual Receipt and Payment',
  SingleWriteOffDetailXls: 'Single Write-off Detail.xls',
  SentOut: 'Sent out!',
  FetchDate: 'Fetch Date',
  ReturnDate: 'Return Date',
  DeclarationDate: 'Declaration Date',
  SailingDate: 'Sailing Date',
  OperationDate: '操作日',
  Contracted: 'Contracted',
  ContractExpired: 'Contract Expired',
  Uncontracted: 'Uncontracted',
  ViewReturnOrderFiles: 'View Return Order Files',
  OnlyWithTheSameStatus: 'Only Print Documents with the Same Status.',
  HouseWaybillNumber: 'House Waybill Number',
  RevokeFetch: 'Revoke Fetch',
  SentOutDate: 'Sent out Date',
  ProvisionedBusiness: 'Provisioned Business',
  ForPleaseChooseUnprovisionedBusiness: 'For Provisioned, Please Choose Unprovisioned Business!',
  ProvisionSuccess: 'Provision Success',
  CancellationProvisionsSuccess: 'Cancellation Provisions Success',
  ProvisionReview: 'Provision Review',
  ProvisionDate: 'Provision Date',
  Booking: 'Booking',
  CustomsClearance: 'Customs Clearance',
  FormalHouseWaybill: 'Formal House Waybill',
  CommodityInspection: 'Commodity Inspection',
  Fumigation: 'Fumigation',
  ForeignTrade: 'Foreign Trade',
  CustomerAttribute: 'Customer Attribute',
  Dropdown: 'Dropdown',
  OrderChannel: 'Order Channel',
  ArrivalDate: 'Arrival Date',
  ShippingOfBillOfLading: 'Shipping Place of Bill of Lading',
  OriginPortPOL: 'Origin Port (POL)',
  DeliveryPlace: 'Delivery Place',
  Route: 'Route',
  FinalDestination: 'Final Destination',
  ShippingCompany: 'Shipping Company',
  ShipAgent: 'Ship Agent',
  TradeMethod: 'Trade Method',
  MasterWaybillTransportTerms: 'Master Waybill Transport Terms',
  HouseWaybillTransportTerms: 'House Waybill Transport Terms',
  MasterWaybillFreightTerms: 'Master Waybill Freight Terms',
  MasterWaybillPaymentLocation: 'Master Waybill Payment Location',
  HouseWaybillFreightTerms: 'House Waybill Freight Terms',
  HouseWaybillPaymentLocation: 'House Waybill Payment Location',
  TradeTerms: 'Trade Terms',
  CargoDimensions: 'Cargo Dimensions',
  SpecialPriceExplanation: 'Special Price Explanation',
  GrossWeightEntrustedActual: 'Gross Weight (Entrusted/Actual)',
  VolumeEntrustedActual: 'Volume (Entrusted/Actual)',
  Packing: 'Packing',
  NumberOfSmallPieces: 'Number of Small Pieces',
  SmallPiecePacking: 'Small Piece Packing',
  ChargeableWeightRT: 'Chargeable Weight RT',
  EnglishProductName: 'English Product Name',
  ShippingMarks: 'Shipping Marks',
  HSCode: 'HS Code',
  ChineseProductName: 'Chinese Product Name',
  CargoSales: 'Cargo Sales',
  OperatingCompany: 'Operating Company',
  OperatingDepartment: 'Operating Department',
  OperationRequirements: 'Operation Requirements',
  OperationTips: 'Operation Tips',
  AdditionalFeeTerms: 'Additional Fee Terms',
  WarehouseEntryInformation: 'Warehouse Entry Information',
  Remarks: '備考',
  CustomField4: 'Custom Field 4',
  Shipper: 'Shipper',
  SecondNotifyParty: 'Second Notify Party',
  EntrustedInformation: 'Entrusted Information',
  VipCooperativeCustomer: 'Vip Cooperative Customer',
  DetailedInformation: 'Detailed Information',
  Transshipment: 'Transshipment',
  AdditionalInformation: 'Additional Information',
  DoorToDoorLoadingCollection: 'Door-to-Door Loading/Collection',
  SelfPickupSelfDelivery: 'Self-Pickup Self-Delivery',
  AutomaticAllocation: 'Automatic Allocation',
  WarehousingInformation: 'Warehousing Information',
  CargoBoxInformation: 'Cargo Box Information',
  OperationInformation: 'Operation Information',
  CustomInformation: 'Custom Information',
  CustomerShippingInformation: 'Customer Shipping Information',
  CodeRetrieval: 'Code Retrieval',
  OperationCannotBeEmpty: 'Operation cannot be empty',
  OperationDepartmentCannotBeEmpty: 'Operation department cannot be empty',
  OperationBranchCannotBeEmpty: 'Operation branch cannot be empty',
  DesignatedFreightAgent: 'Designated Freight Agent',
  DeparturePortAgent: 'Departure Port Agent',
  Client: 'Client',
  DeclaringCustoms: 'Declaring Customs',
  ContainerPackingWarehouse: 'Container Packing/Warehouse',
  WarehouseService: 'Warehouse Service',
  PricingNature: 'Pricing Nature',
  BookingNature: 'Booking Nature',
  PleaseARecordToView: 'Please select a record to view',
  WriteOff: 'Write-off',
  AgeOfAccount: 'Age of Account',
  CommissionAmount: 'Commission Amount',
  TradeType: 'Trade Type',
  PayableWriteOffStatus: 'Payable Write-off Status',
  ReceivableWriteOffStatus: 'Receivable Write-off Status',
  Date: 'Date',
  PleaseEnterTheReviewDate: 'Please enter the review date',
  PleaseConfirmTheReviewDate: 'Please confirm the review date',
  FailedToGetDetails: 'Failed to get details',
  AfterForFinancialReviewContinue: 'After printing the Profit Analysis Table, the business will be submitted for financial review and cannot be changed. Do you want to continue?',
  Warning: 'Warning',
  PleaseNumberBeforePrintingTable: 'Please enter the container seal number before printing the Profit Analysis Table.',
  PleaseSelectCost: 'Please select cost',
  ConfirmTheSingleCostDate: 'Confirm to modify the single cost financial date?',
  CostFinancialDateModificationSuccessful: 'Cost financial date modification successful',
  ConfirmModifyTheFinancialDate: 'Confirm to modify the financial date?',
  FinancialDateModificationSuccessful: 'Financial date modification successful',
  ReviewBusinessDateDoContinue: 'Review date is less than the business date, do you want to continue?',
  ConfirmReviewOfTheseOrders: 'Confirm review of these orders?',
  ThisIsNotIn: 'This business is not in [',
  AllowedToReviewCheck: '] status, not allowed to review, please check!',
  ConfirmToAllowAmendments: 'Confirm to allow amendments?',
  AmendmentAllowedSuccessful: 'Amendment allowed successful',
  NoOrNotInStatus: 'No cost selected or not in review status',
  ConfirmCancellationOfReview: 'Confirm cancellation of review?',
  CostStatusUpdateSuccessful: 'Cost status update successful',
  NoOrNotInStatus2: 'No cost selected or not in submitted status',
  NoOrNotInStatus3: 'No cost selected or not in review status!',
  NoOrNotInStatus4: 'No cost selected or not in submitted status!',
  ConfirmToCancelReview: 'Confirm to cancel review?',
  CancelReviewSuccessful: 'Cancel review successful',
  LCLIndividuallyPleaseReviewBill: 'LCL cannot be reviewed individually, please review the Master Bill.',
  FrontEndErrorCallbackFailed: 'Front-end error: Callback failed',
  CostStatusUpdateSuccessful2: 'Cost status update successful.',
  PleaseStaffInformationBeforePrinting: 'Please enter sales staff information before printing!',
  TheNotEnteredSales: 'The following orders have not entered sales staff information:\n',
  PleaseEnterBeforePrinting: '\nPlease enter before printing!',
  PleaseWantToModifyDate: 'Please select the business you want to modify the business date',
  BusinessDateModificationSuccessful: 'Business date modification successful',
  PleaseSelectOnlyOneRecord: 'Please select only one record',
  InvoicePool_OnlyWithAttachment: '添付ファイルあり',
  PleaseSelectBusiness: 'Please select business.',
  SelectedDataIncludes: 'Selected data includes',
  StatusAllowedToReviewCheck: ' status business, not allowed to review, please check!',
  StatusToCancelReviewCheck: ' status business, not allowed to cancel review, please check!',
  BatchReviewFailed: 'Batch review failed',
  ReviewLessThanBusinessContinue: 'Review date is less than business date, continue?',
  ConfirmToReviewTheseOrders: 'Confirm to review these orders?',
  FinancialReviewList: 'Financial review list',
  QueryFailed: 'Query failed',
  PleaseBusinessYouWantPrint: 'Please select the business you want to print',
  SendEmail: 'Send Email',
  N1ContactAndEmailMaintained: '1. No contact and email maintained:',
  N1AMaintainedContactEmail: '1. Please select a maintained contact and email:',
  N2PleaseAddOtherEmails: '2. Please add other emails:',
  MultipleShouldBeSeparatedCommas: '(Multiple email addresses should be separated by commas)',
  Send: 'Send',
  InvoiceUuidCannotBeEmpty: 'Invoice uuid cannot be empty!',
  SettlementIdCannotBeEmpty: 'Settlement unit id cannot be empty!',
  PleaseEnterEmail: 'Please enter email',
  SendLog: 'Send log',
  Sender: 'Sender',
  YouViewOtherPeoplesFiles: 'You do not have permission to view other people\'s uploaded or printed files.',
  CostName: 'Cost Name',
  PaymentType: 'Payment Type',
  BillingExchangeRate: 'Billing exchange rate',
  BillingAmount: 'Billing amount',
  BillBusinessNumber: 'Bill/Business Number',
  BillBusinessDate: 'Bill/Business Date',
  PriceExclusiveOfTax: 'Price exclusive of tax',
  ResetColumn: 'Reset Column',
  OnlyNumberCanBeSelected: 'Only 1 invoice number can be selected!',
  Used: 'Used',
  Example8180onlyUSDIsInvoice: 'Example: USD:355/exchange rate:6.8180/only USD is accepted for this invoice',
  PleaseNote: 'Please note:',
  ChangesTheNextInvoiceConfiguration: 'Changes will take effect from the next invoice after saving the configuration',
  EBeLessThanCharacters: 'E-invoice remarks must be less than 100 characters',
  PaperBeLessThanCharacters: 'Paper invoice remarks must be less than 200 characters',
  AutomaticTheTextDoesntLine: 'Automatic line break will occur if the text doesn\'t fit in one line',
  PDFDisplayUpToLines: 'PDF invoice remarks can display up to three lines',
  InvoiceType: 'Invoice Type',
  RMBExpenseItemName: 'RMB Expense Item Name',
  USDExpenseItem: 'USD Expense Item',
  DefaultItemName: 'Default Item Name',
  Billing: 'Billing',
  Add: 'Add',
  InternationalFreightForwardingFee: 'International Freight Forwarding Fee',
  InternationalShippingFee: 'International Shipping Fee',
  InternationalFreightServiceFee: 'International Freight Service Fee',
  FreightForwardingFee: 'Freight Forwarding Fee',
  MarkBill: 'Mark Bill',
  MarkCharge: '費用マーク',
  MarkJob: '業務マーク',
  PleaseSelectChargeToMark: 'マークする費用を選択してください。',
  MarkRecordExistsMarkedCharge: 'レコードにマーク済みの費用が存在します。未マークの費用を選択してください。',
  PleaseSelectJobToMark: 'マークする業務を選択してください。',
  MarkRecordExistsMarkedJob: 'レコードにマーク済みの業務が存在します。未マークの業務を選択してください。',
  MarkRecordExistsNoMarkedCharge: 'レコードに未マークの費用が存在します。マーク済みの費用を選択してください。',
  MarkRecordExistsNoMarkedJob: 'レコードに未マークの業務が存在します。マーク済みの業務を選択してください。',
  AnnotationDate: 'Annotation Date:',
  Annotator: 'Annotator:',
  InvoiceInquiry: 'Invoice Inquiry',
  QuickSearchInvoiceNumber: 'Quick Search: Invoice Number',
  SecondaryDownload: 'Secondary Download',
  Sent: 'Sent',
  Unsent: 'Unsent',
  Total: '合計',
  VoidingBulkOperationsPleaseSelectClickVoid: 'Voiding invoices does not support bulk operations\nPlease select one invoice and click【Void】',
  OriginalToReissueTheExpenses: 'Original expenses will be credited; if you need to reissue the invoice, please add the correct expenses！',
  OriginalTheSystemWillExpenses: 'Original expenses will be credited, and the system will automatically generate the same expenses！',
  CreditSuccess: 'Credit success！',
  BankAccount: 'Bank Account',
  OnlyElectronicInvoicesPleaseType: 'Only supports bulk download of electronic invoices, please check invoice type.',
  TotalSelection: 'Total Selection',
  StatusUnknown: 'Status Unknown',
  UnwrittenAmount: 'Unwritten Amount',
  WrittenOffAmount: 'Written-off Amount',
  SearchByExpense: 'Search by Expense',
  QuickSearchBusinessNumber: 'Quick Search: Business Number',
  SearchByBusiness: 'Search by Business',
  SearchByBill: 'Search by Bill',
  QuickSearchBillNumber: 'Quick Search: Bill Number',
  SearchByReconciliationBill: 'Search by Reconciliation Bill',
  QuickSearchReconciliationBillNumber: 'Quick Search: Reconciliation Bill Number',
  SearchByExpenseCredit: 'Search by Expense (Credit)',
  SearchByBusinessCredit: 'Search by Business (Credit)',
  SearchByBillCredit: 'Search by Bill (Credit)',
  SearchByReconciliationBillCredit: 'Search by Reconciliation Bill (Credit)',
  SearchingYouSureYouAgo: 'Searching data beyond two years will affect data loading speed; are you sure you want to query data from more than two years ago?',
  SelectClosingDate: 'Select closing date',
  ClosingDate: 'Closing date:',
  FinancialClosing: 'Financial closing',
  BusinessClosing: 'Business closing',
  ClosingPerson: 'Closing person',
  ClosingMonth: 'Closing month',
  ClosingBranch: 'Closing branch',
  ClosingType: 'Closing type',
  TheHasAlreadyBeenClosed: 'The selected month has already been closed.',
  ClosingSuccess: 'Closing Success',
  PleaseSelectAClosingRecord: 'Please select a closing record.',
  TheBeenAuditedAndCancelled: 'The closing record has been audited and cannot be cancelled.',
  AreWantToCancelRecord: 'Are you sure you want to cancel the closing record?',
  ClosingRecordCancelled: 'Closing record cancelled',
  Year: ' Year ',
  Month: ' Month',
  PleaseSelectARecord: 'Please select a record.',
  AreWantToAuditRecord: 'Are you sure you want to audit the closing record?',
  OperationSuccessful: 'Operation successful.',
  ToYouSureYouAudit: 'To cancel the closing date, are you sure you want to cancel the audit?',
  NoMatchingPrintTemplatesFound: 'No matching print templates found',
  FinancialAudit: 'Financial Audit',
  HangingWaterBill: 'Hanging Water Bill',
  ReceivedPayment: 'Received Payment',
  GotReceipt: 'Got Receipt',
  InternationalBill: 'International Bill',
  AgencySharingBill: 'Agency Sharing Bill',
  PaymentRequestQuery: 'Payment Request Query',
  QuickSearchPaymentRequestNumber: 'Quick Search: Payment Request Number',
  ChangeExpenseApplicationQuery: 'Change Expense Application Query',
  QuickSearchApplicationSerialNumber: 'Quick Search: Application Serial Number',
  SearchByInvoice: 'Search by invoice',
  BankAccountNumber: 'Bank account number',
  NoCorrespondingPrintTemplateFound: 'No corresponding print template found',
  SearchByCost: 'Search by cost',
  ReleasePleasePrepareForWithholding: 'Release has been made, please prepare for cargo withholding.',
  StatusUpdatedSuccessfully: 'Status updated successfully.',
  BillOfLadingConfirmationDocument: 'Bill of lading confirmation document',
  DataCustomersReleaseNotAllowed: 'Data contains blacklisted customers, release not allowed!',
  AreToUseAnNumber: 'Are you sure you want to use an empty release number?',
  Invoice: 'Invoice',
  EquivalentToRMB: 'Equivalent to RMB:',
  ReconciliationFlowNumber: 'Reconciliation flow number',
  CounterpartyUnit: 'Counterparty unit',
  OurBank: 'Our bank',
  PaymentNoticeNumber: 'Payment notice number',
  VoucherNumber: 'Voucher number',
  BankSlipNumber: 'Bank slip number',
  ReconciliationPerson: 'Reconciliation person',
  ReconciliationDate: 'Reconciliation date',
  ReceiptpaymentDate: 'Receipt/payment date',
  VoucherDate: 'Voucher date',
  SlipStatus: 'Slip status',
  ReceiptpaymentMethod: 'Receipt/payment method',
  WhetherPrepaid: 'Whether prepaid',
  Amount: 'Amount',
  AmountReconciled: 'Amount reconciled',
  Balance: 'Balance',
  ActualAmountReceived: 'Actual amount received',
  ActualPaymentAmount: 'Actual payment amount',
  FinancialExpense: 'Financial expense',
  ExchangeGainloss: '為替差損益',
  SmallHead: 'Small head',
  OriginalCurrencyDifference: 'Original currency difference',
  Review: 'Review',
  ReviewDate: 'Review date',
  Void: 'Void',
  InvoiceInformation: 'Invoice information',
  AccountPerioddays: 'Account period (days)',
  CounterpartyVoucherNumber: 'Counterparty voucher number',
  VoucherDate2: 'Voucher date 2',
  FailedToModifyReconciliation: 'Failed to modify reconciliation',
  OffsetSearchAndSelectThe: 'Offset reconciliation: Please search and select all the',
  Fees: 'Fees',
  Invoices: 'Invoices',
  Statements: 'Statements',
  AccountStatements: 'Account Statements',
  PaymentApplications: 'Payment applications',
  PlatformCustomerService: 'Platform customer service',
  FailedToRevokeReconciliation: 'Failed to revoke reconciliation',
  Equivalent: 'Equivalent',
  PaymentAmount: '支払金額',
  PaymentMethod: 'Payment method',
  NotUsed: 'Not used',
  PendingSlip: 'Pending slip',
  ReceivedReceipt: 'Received receipt',
  Reconciliation: 'Reconciliation',
  Company1: 'Company 1',
  CloseAndCopyFlowNumber: 'Close and copy flow number',
  Close: 'Close',
  CopySuccessful: 'Copy successful',
  IfLoadingSpeedAreAgo: 'If the selected date range is more than 2 years, it will affect the data loading speed. Are you sure you want to query data from more than 2 years ago?',
  FinancialComprehensiveQuery: 'Financial comprehensive query',
  ExportEstimationForm: 'Export estimation form',
  ExportingMailboxLaterPleaseMailbox: 'Exporting, will be sent to the login person\'s mailbox later, please check the file in the mailbox.',
  ChineseName: 'Chinese name',
  ClosingRecords: 'Closing records',
  ClosingReview: 'Closing review',
  PleaseCheckARecord: 'Please check a record.',
  PleaseAReconciliationRuleName: 'Please enter a reconciliation rule name',
  PleaseSelectABranch: 'Please select a branch',
  DeleteSuccessful: 'Delete successful',
  PleaseReconciliationRuleToEdit: 'Please select the reconciliation rule to edit',
  PleaseTheMatchingFieldOrder: 'Please enter the matching field order',
  PleaseTheMatchingFieldName: 'Please select the matching field name',
  PleaseTheContrastFieldOrder: 'Please enter the contrast field order',
  PleaseTheContrastFieldName: 'Please select the contrast field name',
  PleaseTheContrastFieldOperation: 'Please select the contrast field operation',
  EnterReconciliationAmount: 'Please enter the "Reconciliation Amount" in the internal table, and make sure that the total amount of the checked reconciliation amounts on both sides are consistent before performing manual reconciliation.',
  XNotAllowViewOrDownload: '{0} file is not allowed to be viewed or downloaded by anyone.',
  NoPermissionView: 'You don\'t have the permission to view or download {0} file',
  SelectedNotAllowedToCheck: 'Selected data includes non {0} status business, not allowed to review, please check!',
  N0isBeVoidedPleaseNote: '{0} is an electronic invoice and cannot be voided, please use a credit note',
  N0isCannotBeVoidedNote: '{0} is a cross-month invoice and cannot be voided, please use a credit note',
  N0VoidedAndCannotCredited: '{0} has been voided and cannot be credited！',
  N0hasOffAndCannotCredited: '{0} has been written off and cannot be credited！',
  N0ItemsDownloadable: ' items, downloadable',
  N0ItemsConfirmDownload: ' items, confirm download?',
  TelexContact0ToApplication: 'Telex release application has been made, please contact {0} to cancel the telex release application.',
  DocumentaryStatus: 'Documentary Status',
  GotIt: 'Got it',
  CurrencyConversionColumnSet: 'Currency Conversion Display Column Settings',
  CurrencyConversionSet: 'Currency Conversion Settings',
  ShowColumns: 'Show Columns',
  CurrencyConversionColumnSetNote: 'Note: After selecting a currency, the system will automatically generate a display column for the original currency amount of the selected currency, or for the amount of expenses converted into this currency',
  CheckAtLeastOneDisplayColumn: 'Please check at least one display column.',
  InvoiceWrittenOffWantDeleteIt: 'The invoice has been written off. Are you sure you want to delete it?',
  InvoiceWrittenOffWantRevokedIt: 'The invoice has been cancelled. Are you sure you want to cancel it?',
  InvoiceWrittenOffWantRedPunchIt: 'The invoice has been written off, please confirm whether it is red offset?',
  RedPunchInvoice: 'Red punch invoice',
  BatchCheckRedFlushInvoiceMessageOne: '1. If there is an error in selecting invoicing, the system will automatically generate a new fee to be invoiced based on the original fee',
  BatchCheckRedFlushInvoiceMessageTwo: '2. If you choose to terminate the service, sell discounts, or return goods, please pay attention to manually re-entering the correct fees',
  BatchCheckRedFlushInvoiceMessageThree: '2. If you choose to terminate the service or return goods, please pay attention to manually re-entering the correct fees',
  IncorrectInvoiceInformation: 'Incorrect invoice information',
  IncorrectChargeInformation: 'Incorrect charge information',
  BatchCheckRedPunchInvoiceMessageOne: '1. If there is an error in selecting invoice information, the system will automatically generate a new expense to be invoiced based on the original expense',
  BatchCheckRedPunchInvoiceMessageTwo: '2. If there is an error in selecting the expense information, please note to manually re-enter the correct expense',
  ContinueRedPunchAtVoucher: 'Please confirm whether to offset the invoice number containing the generated voucher in red?',
  WhtDeduction: 'WHT deduction',
  WhtDeductionAmount: 'WHT deduction Amount',
  ReceivableWHTTaxAmount: 'Receipt minus WHT amount',
  PayableWHTTaxAmount: 'Payment minus WHT amount',
  TotalExcludingTax: 'Total (excluding tax)',
  TotalIncludingTax: 'Total (including tax)',
  NewGeneration: 'Push the new generation status',
  PushState: 'プッシュ状態',
  PushFailReason: 'プッシュ失敗理由',
  ManualMatching: 'Manual matching',
  SelectBusinessNumber: 'Select the corresponding business number',
  ManualMatchByBoxNo: 'Manual matching by box number',
  ManualMatchByWarehouseNo: 'Manual matching by warehouse number',
  FreeMatch: 'Free matching',
  SelectSameSupplierNumberMatch: 'Please select the same supplier number for manual matching.',
  BusinessNoMblSoNoNotEmpty: 'Business number, main order number, and SO NO cannot all be empty',
  SelectCorrespondeBusiness: 'Please select the corresponding business',
  CostSyncColudStatus: 'Cost synchronization cloud platform status',
  SyncCloudExceptionReason: 'Reason for abnormal synchronization of cloud platform',
  ManualSynchronization: 'Manual synchronization',
  SelectNotSyncManualPush: 'Please check the data with a synchronization status of No for manual push',
  SyncChargeNotSplit: 'Synchronized expenses cannot be split',
  SyncCloudPlatformStatus: 'Synchronize cloud platform status',
  InvoiceNoEmptyNotPush: 'Invoice number is empty and cannot be pushed',
  InvoicePushNotAgain: 'Invoices that have been pushed, please do not push again',
  SentYongYouRedFlush: 'Sent to UFIDA, please proceed with the red flush operation',
  InvoiceTitleNotSync: 'The invoice header "{0}" has not been synchronized with UFIDA, please synchronize first.',
  OnlySupportInternal: 'The interface does not include foreign fees. Please select a domestic invoice.',
  NotSupportMultiCurrency: 'There are mixed invoice currencies, unable to push to UFIDA. Please adjust the data.',
  OnlySupportRmb: 'The invoice currency is not RMB and cannot be pushed to UFIDA.',
  PayableInvoiceActualReceiptDateEmpty: 'The actual receipt date of the payable invoice cannot be empty, please fill it in first',
  PushYongYouInvoiceNeedRMB: 'Push UFIDA invoices, requiring invoice currency to be RMB',
  OffsetRedPunchTipU8C: 'According to the group\'s requirements, red invoice cannot be pushed. Please handle it offline',
  AccountsReceivable: 'Accounts receivable:',
  PayableColon: 'Payable:',
  PrintByAccountNumber: 'Print by account number',
  PrintAccordingAccountNumber: 'Print according to the account statement number',
  PrintByPaymentRequestNumber: 'Print by payment request number',
  PushUFIDANeedReceiptDate: 'To push the UFIDA voucher system, the actual receipt date of payable invoices needs to be filled in',
  WhenShareFinanceCost: '(When sharing financial costs)',
  ReceivablesVerificationStatus: '受取業務の検証状態',
  UnlockLedgerBatchNo: 'バッチ番号',
  UnlockLedgerApplyUser: '申請者',
  UnlockLedgerStatus: 'ステータス',
  UnlockLedgerOrderCount: '注文数',
  UnlockLedgerDeclaredImpact: '申告粗利影響',
  UnlockLedgerBeforeProfit: '解除前粗利',
  UnlockLedgerAfterProfit: '解除後粗利',
  UnlockLedgerActualImpact: '実質粗利影響',
  UnlockLedgerRelockTime: '自動再ロック時間',
  UnlockLedgerApplyTime: '提出時間',
  UnlockLedgerStatus0: '承認中',
  UnlockLedgerStatus1: '解除中',
  UnlockLedgerStatus2: '再ロック済',
  UnlockLedgerStatus3: '却下',
  UnlockLedgerManualRemarks: '手動ロック備考',
  UnlockLedgerStatus9: '異常',
  UnlockLedgerDetailTitle: 'ロック解除申請詳細',
  UnlockLedgerApplyInfo: '申請情報',
  UnlockLedgerSpNo: 'WeCom承認番号',
  UnlockLedgerUnlockTime: '解除完了時間',
  UnlockLedgerPlanRelockTime: '計画再ロック時間',
  UnlockLedgerActualRelockTime: '実績再ロック時間',
  UnlockLedgerFailReason: '異常原因',
  UnlockLedgerJobs: '注文スナップショット',
  UnlockLedgerJobNo: '注文番号',
  UnlockLedgerCustomerName: '顧客名',
  UnlockLedgerBeforeReceivable: '解除前売掛',
  UnlockLedgerBeforePayable: '解除前買掛',
  UnlockLedgerAfterReceivable: '再ロック後売掛',
  UnlockLedgerAfterPayable: '再ロック後買掛',
  UnlockLedgerDiffTab: '費用差分明細',
  UnlockLedgerJobFilter: '注文で絞り込み',
  UnlockLedgerChargeName: '費用名称',
  UnlockLedgerChangeType: '変更タイプ',
  UnlockLedgerChangeType0: '追加',
  UnlockLedgerChangeType1: '修正',
  UnlockLedgerChangeType2: '削除',
  UnlockLedgerFieldChanges: '変更フィールド',
  UnlockLedgerModifyUser: '更新者',
  UnlockLedgerModifyTime: '更新時間',
  UnlockLedgerDiffEmptyTip: '差分明細はありません（費用差分は再ロック時に生成されます）',
  UnlockLedgerTip: 'ロック済み注文の費用修正はWeCom承認によるロック解除が必要です。承認後自動的に解除され、3日後の01:00に自動再ロックされます。差分はすべて記録されます'
}
